import { render, staticRenderFns } from "./UnitType.vue?vue&type=template&id=81eded80&"
import script from "./UnitType.vue?vue&type=script&lang=js&"
export * from "./UnitType.vue?vue&type=script&lang=js&"
import style0 from "./UnitType.vue?vue&type=style&index=0&id=81eded80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports